import React from 'react';
import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/material.css';
import '../../styles/phoneinputcustom.css';

function CustomPhoneInput({
  label,
  value,
  onChange,
  error,
  // phoneErrorCls,
  helpertext,
  disabled,
  handleEnter,
}) {
  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <PhoneInput
        placeholder=''
        disabled={disabled}
        countryCodeEditable={false}
        specialLabel={label}
        // inputClass={inputStyles}
        inputStyle={{ width: '100%', height: 25, minWidth: 140 }}
        country={'us'}
        preferredCountries={['us', 'in', 'gb']}
        value={value}
        onChange={onChange}
        enableSearch
        onKeyDown={handleEnter}
      />
      {error && (
        <div
          style={{
            color: 'red',
            fontSize: 10,
            position: 'absolute',
            left: 0,
            bottom: '-15px',
            paddingLeft: 5,
          }}
        >
          {helpertext}
        </div>
      )}
    </div>
  );
}

export default CustomPhoneInput;

//left 9px
